import { api } from '.';
import { APIUrl } from './API-Url';

const currencyApi = api.injectEndpoints({
  endpoints: build => ({
    getCurrency: build.query({
      query: () => ({
        url: `${APIUrl}/currency/rates/`,
        method: 'GET'
      })
    })
  })
});
export const { useGetCurrencyQuery } = currencyApi;
